import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72ea33b6")

_pushScopeId("data-v-72ea33b6")
const _hoisted_1 = {
  key: 0,
  class: "navbar-web"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_4 = {
  key: 1,
  class: "ion-text-center",
  style: {"padding-top":"-10px"}
}
const _hoisted_5 = {
  key: 0,
  class: "selected"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/classes-icon.png"
}, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/classes-icon.png"
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "selected"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/trainers-icon.png"
}, null, -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/trainers-icon.png"
}, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "selected"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/recommended-icon.png"
}, null, -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/recommended-icon.png"
}, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "selected"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/schedule-icon.png"
}, null, -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/schedule-icon.png"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_avatar = _resolveComponent("ion-avatar")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")

  return (_openBlock(), _createBlock(_component_ion_toolbar, null, {
    default: _withId(() => [
      (_ctx.isWeb)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("img", {
              style: {"float":"left","height":"40px","margin":"0 10px"},
              src: _ctx.client.favIconLink
            }, null, 8, ["src"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.webNav, (page, index) => {
              return (_openBlock(), _createBlock("span", { key: index }, [
                (_ctx.pageName == 'Landing' && page == 'HOME' && !_ctx._isAuth)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(''))),
                      slot: "start",
                      fill: "clear",
                      color: "primary"
                    }, {
                      default: _withId(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.pageName != 'Landing' && page == 'HOME' && !_ctx._isAuth)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 1,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage(''))),
                      slot: "start",
                      fill: "clear",
                      color: "medium"
                    }, {
                      default: _withId(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.pageName != 'Join' && page == 'JOIN NOW' && !_ctx._isAuth)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 2,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage('join'))),
                      slot: "start",
                      fill: "clear",
                      color: "medium"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(page), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_ctx.pageName == 'Join' && page == 'JOIN NOW' && !_ctx._isAuth)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 3,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage('join'))),
                      slot: "start",
                      fill: "clear",
                      color: "primary"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(page), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_ctx.pageName != 'About' && page == 'ABOUT US')
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 4,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToPage('about'))),
                      slot: "start",
                      fill: "clear",
                      color: "medium"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(page), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_ctx.pageName == 'About' && page == 'ABOUT US')
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 5,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToPage('about'))),
                      slot: "start",
                      fill: "clear",
                      color: "primary"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(page), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_ctx.pageName.toLowerCase() == page.toLowerCase())
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 6,
                      onClick: ($event: any) => (_ctx.goToPage(page.toLowerCase())),
                      slot: "start",
                      fill: "clear",
                      color: "primary"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(page), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (page != 'HOME' && page != 'ABOUT US' && page != 'JOIN NOW')
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 7,
                        onClick: ($event: any) => (_ctx.goToPage(page.toLowerCase())),
                        slot: "start",
                        fill: "clear",
                        color: "medium"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(page), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx._isAuth)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 0,
                  fill: "clear",
                  color: "medium",
                  style: {"float":"right"},
                  onClick: _ctx.openPopover
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_avatar, {
                      class: "ion-align-self-end",
                      style: {"height":"32px","width":"32px","margin":"0 4px"}
                    }, {
                      default: _withId(() => [
                        (!_ctx.isFetchingProfile)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              style: {},
                              src: _ctx.userProfile?.avatar || _ctx.UserPhoto
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock(_component_ion_spinner, {
                              key: 1,
                              name: "crescent"
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isWeb)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_ion_button, {
              class: "tab-btn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToPage('classes'))),
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                _createVNode("img", {
                  class: "client-icon",
                  src: _ctx.client.favIconLink
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "spacer tab-btn",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToPage('classes'))),
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                (_ctx.$route.name === 'Classes')
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _hoisted_6
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_7, [
                      _hoisted_8
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "spacer tab-btn",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToPage('coaches'))),
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                (_ctx.$route.name === 'Coaches')
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _hoisted_10
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_11, [
                      _hoisted_12
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "spacer tab-btn",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPage('recommended'))),
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                (_ctx.$route.name === 'Recommended')
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _hoisted_14
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_15, [
                      _hoisted_16
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "spacer tab-btn",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToPage('schedule'))),
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                (_ctx.$route.name === 'Schedule')
                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                      _hoisted_18
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_19, [
                      _hoisted_20
                    ]))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})